import { z } from 'zod'
import {
  nullSafeOptionalFirestoreTimestamp,
  nullSafeOptionalString,
  nullSafeOptionalBoolean,
} from '../shared/schema'

export const globalAuthorSchema = z.object({
  authorBio: z.string(),
  authorImageURL: nullSafeOptionalString(),
  authorImageFilename: nullSafeOptionalString(),
  authorInstitution: z.string(),
  authorName: z.string(),
  authorTitle: z.string(),
  // Lowercase fields for prefix-based search (user_search pattern)
  authorNameLower: z.string(),
  authorFirstNameLower: nullSafeOptionalString(),
  authorLastNameLower: nullSafeOptionalString(),
  authorInstitutionLower: z.string(),
  hidden: nullSafeOptionalBoolean(),
  createdAt: nullSafeOptionalFirestoreTimestamp(),
  updatedAt: nullSafeOptionalFirestoreTimestamp(),
})

export const emptyGlobalAuthor = Object.freeze(
  globalAuthorSchema.parse({
    authorBio: '',
    authorImageURL: null,
    authorImageFilename: null,
    authorInstitution: '',
    authorName: '',
    authorTitle: '',
    authorNameLower: '',
    authorFirstNameLower: null,
    authorLastNameLower: null,
    authorInstitutionLower: '',
    createdAt: { seconds: 0, nanoseconds: 0 },
    updatedAt: { seconds: 0, nanoseconds: 0 },
  })
)

export type FirestoreGlobalAuthor = z.infer<typeof globalAuthorSchema>
